import SidebarContentPreview from 'components/SidebarContentPreview';
import { Article, ArticlePreview } from 'interfaces/content/articles/Articles';

export interface MostPopularRRProps {
  articles: ArticlePreview[];
  parent?: Article;
  className?: string;
}

const MostPopularRR = ({ articles, parent, className }: MostPopularRRProps) => (
  <SidebarContentPreview
    title='Most Popular'
    contentPlacementCD='most popular right rail'
    parent={parent}
    type='article'
    items={articles.slice(0, 3)}
    className={className || 'most-popular-rr'}
  />
);

export default MostPopularRR;
